// extracted by mini-css-extract-plugin
module.exports = {"offcanvasMobileSearchArea":"MobileSearch_offcanvasMobileSearchArea__1ce4N"};